// getters
const inventoryProducts = state => state.inventoryProducts

export default {
  inventoryProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/getters.js